var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1797 12.7344V3.59934C19.1797 3.08676 18.7601 2.65625 18.2475 2.65625H13.3254C12.9626 2.65625 12.6331 2.87512 12.4818 3.20484L11.9854 4.2948C11.8341 4.62453 11.5045 4.84375 11.1418 4.84375H2.6382C2.12563 4.84375 1.71875 5.25102 1.71875 5.76363V14.2153C1.71875 14.7279 2.12563 15.1562 2.6382 15.1562H18.2475C18.2721 15.1562 18.2963 15.1422 18.3203 15.1403V16.9141H18.3337C18.3337 17.1484 18.5242 17.3295 18.7567 17.3295C18.9892 17.3295 19.1797 17.1355 19.1797 16.903V12.7344Z",
    fill: "#006DC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7567 17.3295C18.5242 17.3295 18.3337 17.1484 18.3337 16.9141H18.3203V8.2102C18.3203 7.69758 17.9164 7.26562 17.4039 7.26562H1.79453C1.28195 7.26562 0.859375 7.69758 0.859375 8.2102V17.5535C0.859375 18.0661 1.28195 18.4766 1.79453 18.4766H17.4039C17.458 18.4766 17.5109 18.4742 17.5625 18.4653C17.6265 18.4742 17.6918 18.4804 17.7583 18.4804C18.5411 18.4804 19.1698 17.8464 19.1698 17.0636C19.1698 17.0427 19.1684 17.0223 19.1676 17.0016C19.1228 17.1878 18.9553 17.3295 18.7567 17.3295Z",
    fill: "#90CAF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.76aac051b371089859af08d4221ccea9.svg";
export { ForwardRef as ReactComponent };